export default __webpack_public_path__ + "static/media/img-0810-czech-republic-full-face.63d99204.png";